export default __webpack_public_path__ + "static/media/dress14.ad26a677.jpeg";